import React from "react";
import { useTranslation } from "react-i18next";
import { Container } from "../../../../../components/Grid/Grid";
import { SVG_ICONS } from "../../../../../components/__common/Svg/Svg";
import { Typography } from "../../../../../components/__common/Typography/Typography";
import ClickableElement from "../../../../../components/__common/_controls/Button/ClickableElement";
import "./Banner.scss";
import { TTSButton } from "../../../../../components/__common/_controls";

interface Props {
  onClick?: () => void;
}

export const Banner: React.FC<Props> = (Props) => {
  const { t } = useTranslation();
  const { onClick, ...otherProps } = Props;

  return (
    <div
      className={"landingPage-top-banner"}
      id={"landingPage-top-banner"}
      data-testid="landingPage-banner"
    >
      <div className={`landingPage-top-banner__textContainer`}>
        <Container>
          <Container className={"landingPage-top-banner__title"}>
            <Typography
              className={`landingPage-top-banner__title__text`}
              variant="h1"
              component="h1"
            >
              {t("PRIVACY_HUB_BANNER_TEXT1")}
            </Typography>
            <Typography
              className={`landingPage-top-banner__title__text`}
              variant="h1"
              component="h1"
            >
              {t("PRIVACY_HUB_BANNER_TEXT2")}
            </Typography>
          </Container>
          <Container className={`landingPage-top-banner__caption`}>
            <Typography
              className={`landingPage-top-banner__caption__text subText`}
              variant="body1"
            >
              {t("PRIVACY_HUB_BANNER_DESC")}
              <TTSButton
                isWhite={true}
                value={
                  t("PRIVACY_HUB_BANNER_TEXT1") +
                  ". " +
                  t("PRIVACY_HUB_BANNER_TEXT2") +
                  ". " +
                  t("PRIVACY_HUB_BANNER_DESC")
                }
              />
            </Typography>
          </Container>
        </Container>
        <ClickableElement
          onClick={onClick}
          className={`landingPage-top-banner__textContainer__mouseScroll`}
          title={t("PRIVACY_COMMON_NAVIGATE_CONTENT_ALT_TEXT")}
          {...otherProps}
        >
          <img
            src={SVG_ICONS.MOUSE_SCROLL}
            width={58}
            height={58}
            alt="mouse-scroll"
          />
        </ClickableElement>
      </div>
    </div>
  );
};
